const g = {
  device: 'roadshow_web'
}
let IMClientSDK = require('./IMClientWechat.js')
import { lazyload } from './util'
import cookie from '../cookie'
import user from '../user'

import moment from "moment";

let lazyFun = lazyload(1000);

declare let urlid: string;

let channel_id = urlid

let thisuid = ''
if (user.get() != null) {
  thisuid = <string>user.get()?.id
}

const enumMemberSetting = {
  禁言: 10124010,//禁言
  解除禁言: 10124011,
  用户改名申请: 10124013,
  踢出直播间: 10124014,
  通知文档跳转: 10127014,
  主播离开直播间: 10121030,

  通知文档演示结束: 10127015,
  主播通知路演继续: 10121020,
  用户通知路演继续: 10126022,

  连麦状态变更: 10126023,
  用户进入直播间: 10124016,
  用户退出直播间: 10124017,

  发消息: 10111001,
  发图片消息: 10111003,
  收到私信: 10112001,
  发引用消息: 10111002,

  多端登录: 10124200,

  直播开始了: 10121010,
  直播结束了: 10121999,

  请求举手: 10126010,
  取消举手: 10126011,
  允许上麦: 10126012,
  拒绝上麦: 10126013,
  操作下麦: 10126014,   //主持人操作
  用户下麦: 10126015,   //自己操作
  连麦成功: 10126016,
  批量拒绝所有举手申请: 10126017,
  设置禁止举手: 10126020,
  新增公告: 10128000,
  删除公告: 10128001,
  修改公告: 10128002,

  直播间删除: 10121998,
  预告地址变更: 10121400,
  通知直播地址变更: 10121500,

  直播测试结束:1012100130,
  通知直播测试地址变更:1012100110
}

let IMClient: any = null
let this_IMUserID: string
let getNewMessage: Function = function (newmessage: any) {
  console.info(newmessage)
}
let onForbidden = function () {
  console.info('被禁言')
}
let onCancelForbidden = function () {
  console.info('被解除禁言')
}
let onAllForbidden = function () {
  console.info('全员被禁言')
}
let onAllCancelForbidden = function () {
  console.info('全员被解除禁言')
}

let onDocumentShow = function (data: any) {
  console.info('文档跳转')
}
let onDocumentEnd = function () {
  console.info('展示文档结束')
}
let onShowStart = function (data: any) {
  console.info('直播开始了')
}
let onShowEnd = function (data: any) {
  console.info('直播结束了')
}
let onPresentersLeft = function (res:any) {
  console.info('主播离开直播间')
}
let onPresentersContinue = function (res:any) {
  console.info('主播通知路演继续')
}
let onKickOut = function () {
  console.info('被提出直播间')
}
let onNotice = function (txt: string) {
  console.info('发公告')
}

let onDeleteRome = function () {
  console.info('直播间删除')
}

let onChangeForeshow = function (data: any) {
  console.info('预告地址变更')
}
let onChangeLiveshow = function (data: any) {
  console.info('直播地址变更')
}

let onChannelMessagesForPriParams:any = {};
let onChannelMessagesForPri: Function = function (data: any) {
  console.log("获取历史")
}

let onShowTestEnd = function (data: any) {
  console.info('直播测试结束了')
}

let onChangeLiveTestshow = function (data: any) {
  console.info('直播测试地址变更')
}

async function init() {
  IMClient = new IMClientSDK({
    debug: false
  })

  //websocket登录成功以后，登录直播间
  IMClient.on('connected', () => {
    login()
  })

  IMClient.on('allMessages', (res: any, protocol: any) => {
    // console.info('%cprotocol:' + protocol ,'color:green;') 
      // console.info('%cprotocol:' + protocol + ' res:' + JSON.stringify(res),'color:red;')  

    if (protocol == 253) {   //登录反馈
      if (!res.ResultCode) { //没有ResultCode或者0 表示成功
        console.info('im登录成功')

        IMClient.joinChannel(channel_id, 0)
      }
    }
    else if (protocol == 224) {  //订阅频道的反馈（224）            
      if (!res.ResultCode) { //没有ResultCode或者0 表示成功
        console.info('进入房间成功')
        //that.DATA.userCanPostMessage = true //订阅频道成功 用户可以发送消息                     
      } else {
        console.log("进入房间失败" + JSON.stringify(res))
      }

      

      getMessageList()

      // 根据条件获取历史
      getChannelMessagesForPriList(onChannelMessagesForPriParams)
    }
    else if (protocol == 96) {
      if (!res.ResultCode) {
        if (res?.ChannelID == channel_id && res?.UserID == this_IMUserID) {
          if (res.Status == 1) {
            onForbidden()
          }
          else if (res.Status == 2) {
            onCancelForbidden()
          }
        }
        if (res?.ChannelID == channel_id && res.UserID == "") {
          if (res.Status == 1) {
            onAllForbidden()
          }
          else if (res.Status == 2) {
            onAllCancelForbidden()
          }
        }
        // if (res?.ChannelID == channel_id && res?.UserID == this_IMUserID) {
        //     onForbidden()
        // }
      }
    }
    else if (protocol == 179) {
      let notify_type = res?.ContentType
      if (!notify_type) { //没有消息类型
        return
      }
      if (res?.ChannelID != channel_id) {
        console.error('不是当前的房间号')
        return
      }
      console.info(111)

      if (notify_type == enumMemberSetting.发引用消息) {
        console.info(222)

        getNewMessage(res)
      }

    }
    else if (protocol == 174) {  //收到最新的频道消息从
      let content = JSON.parse(res?.Content || {})

      let notify_type = res?.ContentType
      if (!notify_type) { //没有消息类型
        return
      }
      if (res?.ChannelID != channel_id) {
        console.error('不是当前的房间号')
        return
      }

      if (notify_type === enumMemberSetting.新增公告 || notify_type === enumMemberSetting.修改公告) {

        let ggtext = JSON.parse(res.Content).message.content
        onNotice(ggtext)
      }

      //通知直播开始
      if (notify_type === enumMemberSetting.直播开始了) {
        let message = JSON.parse(res.Content).message || {}
        onShowStart(message)
      }
      else if (notify_type === enumMemberSetting.直播结束了) {
        let message = JSON.parse(res.Content).message || {}
        onShowEnd(message)
      }
      // // 用户禁言
      // else if (notify_type == enumMemberSetting.禁言) {
      //     // console.info(this_IMUserID)

      //     let toUserID = content?.to_user?.emuid
      //     if (toUserID && toUserID == thisuid) {
      //         onForbidden()
      //     }

      // }
      // // 解除禁言
      // else if (notify_type == enumMemberSetting.解除禁言) {
      //     // console.info(this_IMUserID)
      //     let toUserID = content?.to_user?.emuid
      //     if (toUserID && toUserID == thisuid) {
      //         onCancelForbidden()
      //     }

      // }
      else if (notify_type == enumMemberSetting.用户改名申请) {

      }
      //踢出直播间 
      else if (notify_type == enumMemberSetting.踢出直播间) {
        let toUserID = content?.to_user?.emuid
        if (toUserID && toUserID == thisuid) {
          onKickOut()
        }
      }
      // 文档演示
      else if (notify_type == enumMemberSetting.通知文档跳转) {
        onDocumentShow(res)
      }
      else if (notify_type == enumMemberSetting.通知文档演示结束) {
        onDocumentEnd()
      }
      //更新成员列表
      else if (notify_type == enumMemberSetting.用户进入直播间) {


      }
      else if (notify_type == enumMemberSetting.用户退出直播间) {

      }
      else if (notify_type == enumMemberSetting.发消息) {
        getNewMessage(res)
      }

      else if (notify_type == enumMemberSetting.收到私信) {
        getNewMessage(res)
      }
      else if (notify_type == enumMemberSetting.发引用消息) {
        getNewMessage(res)
      }
      else if (notify_type == enumMemberSetting.发图片消息) {

      }
      else if (notify_type == enumMemberSetting.主播通知路演继续) {
        onPresentersContinue(res)
      }
      else if (notify_type == enumMemberSetting.用户通知路演继续) {

      }
      else if (notify_type == enumMemberSetting.主播离开直播间) {
        onPresentersLeft(res)

      }
      else if (notify_type == enumMemberSetting.直播间删除) {
        onDeleteRome()
      }
      else if (notify_type == enumMemberSetting.预告地址变更) {
        let message = JSON.parse(res.Content).message
        onChangeForeshow(message)
      }

      else if (notify_type == enumMemberSetting.通知直播地址变更) {
        let message = JSON.parse(res.Content).message
        onChangeLiveshow(message)
      }
      
      else if (notify_type == enumMemberSetting.直播测试结束) {
        let message = JSON.parse(res.Content).message || {}
        onShowTestEnd(message)
      }
      
      else if (notify_type == enumMemberSetting.通知直播测试地址变更) {
        let message = JSON.parse(res.Content).message || {}
        onChangeLiveTestshow(message)
      }


    }
  })


}

init()

function login() {
  if (cookie.get('ct') && cookie.get('ut')) {
    IMClient.authUser({
      ct: cookie.get('ct'),
      ut: cookie.get('ut'),
      source: 2,
      device: g.device,
      version: 1,
      success: (res: any) => {
        console.info('获取token成功')

        let { IMUserID, RefreshToken, Token } = res?.data || {}
        if (IMUserID && RefreshToken && Token) {
          this_IMUserID = IMUserID

          IMClient.loginByIMToken(IMUserID, Token, g.device, 1, RefreshToken)
        }
        else {
          console.info('IMUserID:为空')
        };

        (<any>self).CertifiedType = res?.data?.CertifiedType; 
      },
      fail: function (e: any) {
        console.info('失败了！', e)
      }
    })
  }
  else {
    IMClient.anonymousUser({
      NickName: '未登录用户' + Math.floor(Math.random() * 10000 + 1),
      Version: '0',
      IMUserID: '',
      Device: g.device,
      version: 1,
      success: (res: any) => {
        console.info('获取token成功')

        let { IMUserID, RefreshToken, Token } = res?.data || {}
        if (IMUserID && RefreshToken && Token) {
          this_IMUserID = IMUserID
          IMClient.loginByIMToken(IMUserID, Token, g.device, 1, RefreshToken)
        }
        else {
          console.info('IMUserID:为空')
        }
      },
      fail: function (e: any) {
        console.info('失败了！', e)
      }
    })
  }
}

let getListCallback: Function = function (data: any) {
  // console.info(data)
}

let getHistoryListCallback: Function = function (data: any) {
  // console.info(data)
}
/**
 * 每页多少条
 */
const pageSize = 100;
/**
 * 最多多少页
 */
const maxPage = 5;

async function getMessageByPage(maxindex: number): Promise<{
  data: Array<any>,
  maxindex: number
}> {
  return new Promise(function (resovle, reject) {
    IMClient.getMessageOrderListByIndex({
      channelID: channel_id,
      index: maxindex,
      descOrder: true,
      pageSize: pageSize,
      success: function (backdata: any) {
        //console.info(data)
        //data.data = data.data.reverse()
        var nowmaxindex = 0
        var returndata = []
        //if(backdata.result == 1 && backdata.data && backdata.data.length > 0){
        try {
          nowmaxindex = JSON.parse(backdata.data[backdata.data.length - 1].Content).MsgIndexID - 1
        } catch (error) {

        }
        try {
          returndata = backdata.data
        } catch (error) {

        }
        //}
        resovle({
          data: returndata,
          maxindex: nowmaxindex
        })
        // getListCallback(data)
      }
    })
  })
}

async function getMessageListAll(maxindex: number) {
  let maxindexnow = maxindex
  let numberarray = []
  let messagedataall: Array<any> = []
  for (let index = 0; index < maxPage; index++) {
    numberarray.push(index + 1)
  }
  for await (let nowindex of numberarray) {
    // console.info(nowindex)

    let backdata = await getMessageByPage(maxindexnow)
    messagedataall = messagedataall.concat(backdata.data)
    if (backdata.data.length == 0 || maxindex == 0) {
      break;
    }
    maxindexnow = backdata.maxindex
    // console.info(maxindexnow)

  }
  // console.info(messagedataall)
  return messagedataall.reverse()
}

/**
 * 获取聊天记录
 */
async function getMessageList() {
  IMClient.getMaxIndex({
    channelID: channel_id,
    success: function (maxdata: any) {
      let maxindex = maxdata.data

      setTimeout(() => {
        // 
        // IMClient.getMessageOrderListByIndex({
        //     channelID: channel_id,
        //     index: maxindex,
        //     descOrder: true,
        //     pageSize: 100,
        //     success: function (data: any) {
        //         //console.info(data)
        //         data.data = data.data.reverse()
        //         getListCallback(data)
        //     }
        // })    
        getMessageListAll(maxindex).then(function (backdata) {
          getListCallback(backdata)
        })
      }, 1500);

    },
    fail: function (back: any) {

      getListCallback(null);

      console.info('获取message最大index失败')

    }
  })

}

/**
 * 根据条件查询历史记录
 *
 */
async function getChannelMessagesForPriList(paramsobj:any) {
  IMClient.getChannelMessagesForPri({
    params: { 
      channelID: channel_id,
      pageIndex: paramsobj.pageIndex || 1,
      pageSize: paramsobj.pageSize || 20,
      orderby: 1,  //0顺序 1倒序
      beginTime: "2010-01-01",
      endTime: moment().format("YYYY-MM-DD")
    },
    success: function (res: any) {

      setTimeout(() => {
        let data = JSON.parse(res?.data);

        onChannelMessagesForPri(data?.data);
      }, 1500);
    },
    fail: function (back: any) {
      console.info('获取历史chat失败')

    }
  })
}

export default {
  getList: function (callback: Function) {
    getListCallback = callback
  },
  //  根据条件获取历史记录
  getHistoryListForPri: function (params:any,callback: Function) {
    onChannelMessagesForPriParams = params;
    onChannelMessagesForPri = callback
  },
  regGetNewMessage: function (callback: Function) {
    getNewMessage = callback
  },
  /**
   * 被禁言
   * @param callback 
   */
  onForbidden: function (callback: () => void) {
    onForbidden = callback
  },
  /**
   * 被解除禁言
   * @param callback 
   */
  onCancelForbidden: function (callback: () => void) {
    onCancelForbidden = callback
  },

  /**
   * 全员被禁言
   * @param callback 
   */
  onAllForbidden: function (callback: () => void) {
    onAllForbidden = callback
  },
  /**
   * 全员被解除禁言
   * @param callback 
   */
  onAllCancelForbidden: function (callback: () => void) {
    onAllCancelForbidden = callback
  },

  sendNewMessage: async function (newmessage: string) {
    return new Promise((resolve: any, reject: any) => {
      IMClient.sendToChannel({
        channelID: channel_id,
        contentType: enumMemberSetting.发消息,
        persist: true,
        content: JSON.stringify({
          txt: newmessage,
          ua: "web;lk.web"
        }),
        seq: (new Date()).getTime(),
        success: function () {
          resolve()
        },
        fail: function (message: string) {
          reject(new Error(message))
        }
      })
    })

  },
  sendNewQuoteMessage: async function (newmessage: string, quotemessage: any) {
    // console.info(quotemessage)

    return new Promise((resolve: any, reject: any) => {
      IMClient.sendChannelQuoteMessage({
        channelID: channel_id,
        contentType: enumMemberSetting.发引用消息,
        persist: true,
        content: JSON.stringify({
          txt: newmessage,
          ua: "web;lk.web"
        }),
        seq: (new Date()).getTime(),
        quoteMessage: quotemessage,
        success: function () {
          resolve()
        },
        fail: function (message: string) {
          reject(new Error(message))
        }
      })
    })

  },
  regDocumentShow: function (callback: any) {
    onDocumentShow = callback
  },
  regDocumentEnd: function (callback: any) {
    onDocumentEnd = callback
  },
  /**
   * 直播开始
   * @param callback 
   */
  onShowStart: function (callback: any) {
    onShowStart = callback
  },
  /**
   * 直播结束
   * @param callback 
   */
  onShowEnd: function (callback: any) {
    onShowEnd = callback
  },
  /**
   * 主播离开直播间
   * @param callback 
   */
  onPresentersLeft: function (callback: any) {
    onPresentersLeft = callback
  },

  /**
   * 主播通知路演继续
   * @param callback 
   */
  onPresentersContinue: function (callback: any) {
    onPresentersContinue = callback
  },

  /**
   * 被提出直播间
   */
  onKickOut: function (callback: any) {
    onKickOut = callback
  },
  onNotice: function (callback: any) {
    onNotice = callback
  },
  /**
   * 删除直播间
   * @param callback 
   */
  onDeleteRome: function (callback: any) {
    onDeleteRome = callback
  },

  /**
   * 预告地址变更
   * @param callback 
   */
  onChangeForeshow: function (callback: any) {
    onChangeForeshow = callback
  },

  /**
   * 直播地址变更
   * @param callback 
   */
  onChangeLiveshow: function (callback: any) {
    onChangeLiveshow = callback
  },

  /**
   * 直播测试结束
   * @param callback 
  */
  onShowTestEnd: function (callback: any) {
      onShowTestEnd = callback
  },

  /**
 * 直播测试地址变更
 * @param callback 
 */
  onChangeLiveTestshow: function (callback: any) {
    onChangeLiveTestshow = callback
  }

}